"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var types = {
  document: 'document',
  template: 'template',
  version: 'version'
};
var _default = exports["default"] = types;